import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/Navbar.css";

function MenuNavbar({
	sections,
	selectedSection,
	setSelectedSection,
	isMobileOpen,
	setIsMobileOpen,
}) {
	const [localOpen, setLocalOpen] = useState(false);
	const isCategoryMenuOpen =
		typeof setIsMobileOpen === "function" ? isMobileOpen : localOpen;
	const toggleCategoryOpen = () => {
		if (typeof setIsMobileOpen === "function") setIsMobileOpen(!isMobileOpen);
		else setLocalOpen(!localOpen);
	};
	const handleSectionClick = (section) => {
		setSelectedSection(section === selectedSection ? "" : section);
		window.scrollTo(0, 0);
		if (typeof setIsMobileOpen === "function") setIsMobileOpen(false);
		else setLocalOpen(false);
	};

	return (
		<div className="relative md:sticky md:top-28 left-0 right-0 z-[5] bg-white/95 backdrop-blur-sm border-b border-gray-100 mt-8 md:mt-0">
			{/* Mobile Menu Button - hidden when external control is provided */}
			{typeof setIsMobileOpen !== "function" && (
				<div className="md:hidden flex justify-center items-center text-black px-4 py-3">
					<span className="text-sm font-medium text-[#856746]">
						{"Explore Our Menu Categories"}
					</span>
					<button
						onClick={toggleCategoryOpen}
						className="p-2 text-[#856746] hover:text-[#60462c] transition-colors rounded-full bg-gray-200 hover:bg-gray-300 ml-4"
						aria-label="Toggle menu categories"
					>
						<svg
							className="w-6 h-6"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M4 6h16M4 12h16M4 18h16"
								color="black"
							/>
						</svg>
					</button>
				</div>
			)}

			{/* Mobile Category Menu */}
			<AnimatePresence>
				{isCategoryMenuOpen && (
					<motion.div
						initial={{ opacity: 0, y: -10 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -10 }}
						transition={{ duration: 0.2 }}
						className="md:hidden bg-white border-t border-gray-100 shadow-lg"
					>
						<div className="py-1 flex flex-col items-center">
							{sections.map((section) => (
								<button
									key={section}
									onClick={() => handleSectionClick(section)}
									className={`w-full text-center px-6 py-3 text-sm transition-colors duration-200
                    ${
											selectedSection === section
												? "text-[#8b5e34] bg-[#8b5e34]/5 font-medium"
												: "text-gray-600 hover:bg-gray-50"
										}`}
									aria-label={`Select ${section} category`}
								>
									{section}
								</button>
							))}
						</div>
					</motion.div>
				)}
			</AnimatePresence>

			{/* Desktop Categories */}
			<div className="hidden md:block py-4">
				<div className="flex justify-center items-center gap-8 px-4">
					{sections.map((section) => (
						<button
							key={section}
							onClick={() => handleSectionClick(section)}
							className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap pb-1
                ${
									selectedSection === section
										? "text-[#8b5e34] border-b-2 border-[#8b5e34]"
										: "text-gray-600 hover:text-[#8b5e34]"
								}`}
						>
							{section.toUpperCase()}
						</button>
					))}
				</div>
			</div>
		</div>
	);
}

export default MenuNavbar;
